<div class="columns is-vcentered">
    <div class="column is-two-fifths" style="text-align: right;">
        <img src="assets/version2/signup-banner.jpg" alt="">
    </div>
    <div class="column">
    <div class="title">{{'LblIylonConnect' | translate}}</div>
    <div class="formContainer" *ngIf="editDetails===false">
        <div class="column is-three-quarters">
            <form [formGroup]="addIylonConnectForm">
                <formly-form [model]="addIylonConnectmodel" [fields]="iylonConnectfields" [options]="addIylonConnectoptions"
                    [form]="addIylonConnectForm">
                </formly-form>
            </form>
            <button class="section-header button transparent-button"
                (click)="submitConnectForm()">{{'LblSubmitbutton'|translate}}</button>
        </div>
    </div>
    <div class="formContainer" *ngIf="editDetails===true">
        <div class="column is-three-quarters">
            <form [formGroup]="addIylonConnectForm">
                <formly-form [model]="addIylonConnectmodel" [fields]="iylonConnectfields" [options]="addIylonConnectoptions"
                [form]="addIylonConnectForm">
            </formly-form>

            </form>

            <!-- <button class="section-header button transparent-button"
            (click)="submitConnectForm()">{{'LblSubmitbutton'|translate}}</button> -->
            
            <br>

            <button class="section-header button transparent-button"(click)="sendPaymentEmail()">{{'LblSendPaymentLink'|translate}}</button>



        </div>

    </div>
</div>
</div>
